export const markdownStyles = `
  .markdown-preview h1 {
    font-size: 2em;
    margin-top: 0.67em;
    margin-bottom: 0.67em;
    font-weight: bold;
    color: #ffffff;
  }
  
  .markdown-preview h2 {
    font-size: 1.5em;
    margin-top: 0.83em;
    margin-bottom: 0.83em;
    font-weight: bold;
    color: #ffffff;
  }
  
  .markdown-preview h3 {
    font-size: 1.17em;
    margin-top: 1em;
    margin-bottom: 1em;
    font-weight: bold;
    color: #ffffff;
  }
  
  .markdown-preview h4 {
    font-size: 1em;
    margin-top: 1.33em;
    margin-bottom: 1.33em;
    font-weight: bold;
    color: #ffffff;
  }
  
  .markdown-preview h5 {
    font-size: 0.83em;
    margin-top: 1.67em;
    margin-bottom: 1.67em;
    font-weight: bold;
    color: #ffffff;
  }
  
  .markdown-preview h6 {
    font-size: 0.67em;
    margin-top: 2.33em;
    margin-bottom: 2.33em;
    font-weight: bold;
    color: #ffffff;
  }
  
  .markdown-preview p {
    margin-top: 1em;
    margin-bottom: 1em;
  }
  
  .markdown-preview strong, .markdown-preview b {
    font-weight: bold;
  }
  
  .markdown-preview em, .markdown-preview i {
    font-style: italic;
  }
  
  .markdown-preview code {
    font-family: 'Menlo', 'Monaco', 'Courier New', monospace;
    background-color: #2d2d2d;
    padding: 0.2em 0.4em;
    border-radius: 3px;
  }
  
  .markdown-preview pre {
    background-color: #2d2d2d;
    padding: 1em;
    overflow-x: auto;
    border-radius: 5px;
    margin: 1em 0;
  }
  
  .markdown-preview blockquote {
    padding-left: 1em;
    border-left: 4px solid #555;
    margin: 1em 0;
    color: #aaa;
  }
  
  .markdown-preview ul, .markdown-preview ol {
    margin: 1em 0;
    padding-left: 2em;
  }
  
  .markdown-preview a {
    color: #61afef;
    text-decoration: underline;
  }
  
  .markdown-preview hr {
    border: 0;
    height: 1px;
    background-color: #555;
    margin: 2em 0;
  }
  
  .markdown-preview table {
    border-collapse: collapse;
    margin: 1em 0;
    width: 100%;
  }
  
  .markdown-preview th, .markdown-preview td {
    border: 1px solid #555;
    padding: 8px 12px;
    text-align: left;
  }
  
  .markdown-preview th {
    background-color: #2d2d2d;
    font-weight: bold;
  }
`;
